import { MemberVerificationStatusService } from 'types/services';
import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';

export const toggleMemberVerivicationStatus: MemberVerificationStatusService = async params => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
